import axios from "axios";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { LOCALES } from "common/constants";
import { Link } from "react-router-dom";

const ActionProvider = ({
  createChatBotMessage,
  setState,
  children,
  stateRef,
  createClientMessage,
  createCustomMessage,
  ...rest
}) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state?.auth);
  const language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    reset();
  }, [language]);

  const reset = () => {
    const message = createChatBotMessage(t("How may i help you?"));
    setState((prevState) => ({
      ...prevState,
      messages: [message],
    }));
  };

  // const askForNumber = () => {
  //   const message = createChatBotMessage(t("Please enter your phone number."), {
  //     numberNext: true,
  // });
  //   addMessageToState(message);
  // };

  const askForDescription = () => {
    const message = createChatBotMessage(
      t("Please write in a few words about the issue you are facing."),
      {
        descriptionNext: true,
      }
    );
    addMessageToState(message);
  };

  const helpAPI = () => {
    const message = createChatBotMessage(t("Thanks for contacting us."));
    addMessageToState(message);
  };

  const contactUs = () => {
    // axios
    //   .post("/chatbox/user-ques", {
    //     description: message,
    //     email: children.props.children.props.state.messages[1].message,
    //     phoneNo: children.props.children.props.state.messages[3].message,
    //   })
    //   .then((data) => {
    const message = createChatBotMessage(
      <>
        {t("Please contact us by email or phone number")} <br />
        {/* {t("Call Us at")} */}
        <a className="text-light" href={`tel:${import.meta.env.VITE_SUPPORT_PHONE_NUMBER}`}>
          <u>
            <span> {t("Phone")} : </span> <br />
            {import.meta.env.VITE_SUPPORT_PHONE_NUMBER}
          </u>
        </a>
        {/* {t("or write us at")} */}
        <br />
        <a className="text-light" href="mailto:support@invozio.com">
          <u>
            <span>{t("Email")} : </span>
            <span>support@invozio.com</span>
          </u>
        </a>
      </>
    );
    addMessageToState(message);
    // })
    // .catch(() => {
    //   const message = createChatBotMessage(
    //     t("We did not get your question please type it again")
    //   );
    //   addMessageToState(message);
    // });
  };

  const question = () => {
    const message = createChatBotMessage(
      <>
        {t("Have you checked that your questions are not on our")}
        <Link
          style={{ textDecoration: "underline" }}
          className="text-light cursor-pointer"
          to={`${
            user
              ? language === LOCALES.EN_US
                ? `/dashboard/faq?lang=${LOCALES.EN_US}`
                : `/instrumentbrada/faq?lang=${LOCALES.SV_SE}`
              : language === LOCALES.EN_US
              ? `/faq?lang=${LOCALES.EN_US}`
              : `/faq?lang=${LOCALES.SV_SE}`
          }`}
          target="_blank"
        >
          <u> FAQ </u>
        </Link>
      </>
    );
    const message1 = createChatBotMessage(
      t("Does this answer your question?"),
      { widget: "options" }
    );
    addMessageToState(message);
    addMessageToState(message1);
  };

  const successMessage = async (message) => {
    try {
      const userMessage = message;
      const questionArray = await axios.get("/chatbox");
      const allQuestions = questionArray.data.response.map((questions) => {
        return questions.question.split(" ");
      });
      const filteredQuestion = allQuestions.map((values) => {
        return values.filter((element) =>
          userMessage.toLowerCase().split(" ").includes(element)
        ).length;
      });
      try {
        const answer = await axios.post("/chatbox/chat", {
          description: userMessage,
          questionDB: filteredQuestion.every((item) => item === 0)
            ? ""
            : allQuestions[
                filteredQuestion.indexOf(Math.max(...filteredQuestion))
              ]
                .toString()
                .replace(/,/g, " "),
        });
        const message = createChatBotMessage(
          answer.data.response.choices[0].text
        );
        const message1 = createChatBotMessage(
          t("Does this answer your question?"),
          { widget: "options" }
        );
        addMessageToState(message);
        addMessageToState(message1);
      } catch (error) {
        const message = createChatBotMessage(
          t("We did not get your question please type it again")
        );
        addMessageToState(message);
      }
    } catch (error) {}
  };

  const addMessageToState = (message) => {
    setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages, message],
    }));
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
            reset,
            helpAPI,
            question,
            contactUs,
            // askForNumber,
            successMessage,
            // askForDescription,
            addMessageToState,
          },
        });
      })}
    </div>
  );
};

export default ActionProvider;
